import { IGoodsCard } from 'types/goods';
import env from 'libs/env';

export function getTagImg(goods: IGoodsCard, i: number) {
    if (goods.activity_current && goods.activity_current.tag_img) {
        const imgArr = goods.activity_current.tag_img.split(',');
        if (imgArr[i]) return imgArr[i];
    }

    return '';
}

function shouldDisplayActivity() {
    return env.isInToutiaoProduct || env.isInWechat;
}

export function inActivity(goods: IGoodsCard) {
    if (!shouldDisplayActivity()) {
        return false;
    }
    if (goods.activity_current && goods.activity_current.campaign_id === '3280848729556555321') {
        return false;
    }
    if (goods.activity_current && typeof goods.activity_current.sale_price === 'number') {
        const begin = new Date(goods.activity_current.begin_time * 1000).getTime();
        const end = new Date(goods.activity_current.end_time * 1000).getTime();
        const now = Date.now();
        return (
            begin <= now &&
            now <= end &&
            goods.activity_current.left_stock > 0 &&
            goods.activity_current.status === 0
        );
    } else {
        return false;
    }
}

export function sellOut(goods: IGoodsCard) {
    const checkGoodInfo = goods.sku_max_price === 0 && goods.sku_min_price === 0;
    if (goods?.activity_current) {
        const activity = goods.activity_current;
        return checkGoodInfo && activity?.sku_max_price === 0 && activity?.sku_min_price === 0;
    }
    return checkGoodInfo;
}

export function isPreHeating(goods: IGoodsCard) {
    if (!goods.activity_current) {
        return false;
    }
    const begin = new Date(goods.activity_current.begin_time * 1000).getTime();
    const now = Date.now();

    return now < begin;
}

export function computePrice(goods: IGoodsCard) {
    if (goods.activity_current && inActivity(goods)) {
        // 是以分为单位的
        return goods.activity_current.sale_price / 100;
    }

    if (goods.activity_current && isPreHeating(goods)) {
        // 是以分为单位的
        return goods.activity_current.sale_price / 100;
    }

    return calPrice(goods);
}

export function calPrice(goods: IGoodsCard) {
    if (goods.stype === 2) {
        // 活动价格优先级最高
        return goods.campaign_price_new / 100;
    } else if (goods.sku_min_price) {
        // 这个价格的优先级比discount_price高，但是比campaign_price_new低
        return goods.sku_min_price / 100;
    } else {
        return goods.discount_price / 100;
    }
}

export function canUseCoupon(goods: IGoodsCard) {
    return (
        goods.stype !== 2 &&
        goods.coupon_label &&
        (!goods.activity_current || goods.activity_current.stype !== 2)
    );
}

export function inCampaign(goods: IGoodsCard) {
    // 如果 goods 本身有 stype === 2，或者在单独的活动中，且活动类型为 2。
    return (
        goods.stype === 2 ||
        (inActivity(goods) && goods.activity_current && goods.activity_current.stype === 2)
    );
}

export function computeCampaignDifference(goods: IGoodsCard) {
    if (goods.activity_current && inActivity(goods)) {
        return (goods.discount_price - goods.activity_current.sale_price) / 100;
    } else {
        return (goods.discount_price - goods.campaign_price_new) / 100;
    }
}

export function getSellText(goods: IGoodsCard) {
    if (Number(goods.sell_num) === 0) return '';
    return `已售${goods.sell_num}`;
}

export const getReturnType = (returnType: string) => {
    const ReturnType = {
        Support: '1',
        Unsupport: '0',
        Partial: '2'
    };
    interface ReturnContent {
        text: string;
        type: string;
    }
    interface IReturnType {
        [key: string]: ReturnContent;
    }
    const returnMap: IReturnType = {
        [ReturnType.Support]: { text: '7天无理由退货', type: 'normal' },
        [ReturnType.Unsupport]: { text: '不支持7天无理由退货', type: 'disable' },
        [ReturnType.Partial]: { text: '拆封前支持7天无理由退货', type: 'normal' }
    };
    return returnMap[returnType];
};

export const getDeliverTag = (day: number | undefined) => {
    if (!day) return '';
    return day <= 2 ? `下单后${day * 24}小时内发货` : day && `下单后${day}天内发货`;
};
